export function useSlideTitle() {
  return "Agricultural Commodity Prices";
}